import * as React from 'react';
import * as classNames from "classnames";

export interface ExpandableProps {
    allowClose: boolean;
    allowExpand: boolean;
    defaultClosed?: boolean;
    title: string;
    icon?: string;
    onClose?: Function;
    className?: string;
    style?: any;
  }

class Expandable extends React.PureComponent<ExpandableProps, any> {
    constructor(props, context) {
        super(props, context);
        this.state = {show: this.props.defaultClosed ? !this.props.defaultClosed : true};
        this.onClose = this.onClose.bind(this);
        this.onToggleOpen = this.onToggleOpen.bind(this);
    }

    onToggleOpen(){
        this.setState({show: !this.state.show});
    }

    onClose(){
        this.props.onClose();
    }

    render() {
        let icon = this.props.icon ? <img src={this.props.icon} width="30" /> : undefined;

        let header = this.props.title ? <div>
                                                { this.props.allowClose ? <i onClick={this.onClose} className={classNames("pull-right fa fa-times")} /> : undefined }
                                                { this.props.allowExpand ? <i onClick={this.onToggleOpen} className={classNames("pull-right fa", {"fa-chevron-down": this.state.show, "fa-chevron-up": !this.state.show})} /> : undefined }
                                                <strong>{icon} {this.props.title}</strong>
                                        </div> : undefined;

        return (<div style={this.props.style} className={classNames(this.props.className, {"bg-white": this.props.title != undefined})}>
                    {header}
                    { this.state.show ? 
                        <div>
                            {this.props.children}
                        </div>
                        : undefined }
                </div>);
    }
}

export default Expandable;
